import {
  ActivatedRouteSnapshot,
  Resolve,
  RouterStateSnapshot,
} from '@angular/router';
import { Observable, catchError, of, tap } from 'rxjs';
import { Store } from '@ngrx/store';

import { AppState } from '../core/state/app.state';
import { Injectable } from '@angular/core';
import { User } from '../core/models/core.models';
import { UserApiService } from 'src/app/api/services/user-api.service';
import { setAdminCurentUser } from './state/admin-users.actions';

@Injectable({
  providedIn: 'root',
})
export class UserResolver implements Resolve<User> {
  constructor(
    private userApi: UserApiService,
    private store: Store<AppState>,
  ) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<User | null> {
    const userId = route.paramMap.get('userId');

    if (route.data['createObject'] || !userId) {
      this.store.dispatch(setAdminCurentUser({ user: null }));
      return of(null); // Directly return null if no userId or creating a new user
    }

    return this.userApi.getUser(userId).pipe(
      tap((user: User) => {
        this.store.dispatch(setAdminCurentUser({ user }));
      }),
      catchError((error) => {
        console.error('Failed to fetch user', error);
        this.store.dispatch(setAdminCurentUser({ user: null }));
        return of(null);
      }),
    );
  }
}
